<template>
  <form class="row form tournament-user-registration-form">
    <component
      :is="getComponent(field)"
      v-for="field in fields"
      :key="field.id"
      v-model="localFieldValues[field.id]"
      v-validate="{
        required: field.required,
      }"
      :required="!!field.required"
      :name="field.id"
      :error="errors.first(field.id)"
      :data-vv-as="
        $t(
          `_web_tournament-join-form-${field.associate_field}-associate`,
          field.label
        )
      "
      :label="field.label"
      :label-font-size="0.875"
      :error-font-size="0.75"
      :date-format="'MMM D YYYY'"
      :max-date="field.label === 'Date of Birth' ? getNowSeconds() : undefined"
      :placeholder="field.placeholder"
      class="min-w-100 input-wrapper-reg-form"
      :class="[
        itemClasses,
        $validator.errors.has(field.id) ||
        (field.field_type === 'number' &&
          localFieldValues[field.id] &&
          localFieldValues[field.id].toString().length > 18)
          ? 'border-error'
          : '',
      ]"
    />
  </form>
</template>

<script>
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import CountryInput from '@/components/molecules/form/autoComplete/Country';
import CityInput from '@/components/molecules/form/autoComplete/City';
import DateInput from '@/components/form/DatePicker.vue';
import NumberInput from '@/components/form/NumberInput';
import dateMethods from '@/mixins/dateMethods';

const COMPONENTS = {
  default: 'TextInput',
  input: 'TextInput',
  country: 'CountryInput',
  date: 'DateInput',
  number: 'NumberInput',
};

export default {
  inject: ['$validator'],
  components: {
    TextInput,
    CountryInput,
    CityInput,
    DateInput,
    NumberInput,
  },
  mixins: [...dateMethods],
  model: {
    prop: 'fields',
    event: 'update',
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    itemClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localFieldValues: {},
    };
  },
  watch: {
    fields: {
      deep: true,
      handler() {
        this.$nextTick(this.fillLocalFieldValues);
      },
    },
    localFieldValues: {
      deep: true,
      handler(v) {
        const fields = this.$lodash.cloneDeep(this.fields).map(field => ({
          ...field,
          value: this.$lodash.get(v, `[${field.id}].value`, v[field.id]),
        }));
        this.$emit('update', fields);
      },
    },
  },
  created() {
    this.fillLocalFieldValues();
  },
  methods: {
    getComponent({ field_type }) {
      return COMPONENTS[field_type] || COMPONENTS.default;
    },
    fillLocalFieldValues() {
      this.fields.forEach(({ id }, index) => {
        if (this.localFieldValues.hasOwnProperty(id)) {
          return;
        }
        this.$set(this.localFieldValues, id, this.fields[index].value);
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
  },
};
</script>

<style lang="scss" scoped>
.border-error {
  input {
    border: 1px solid rgb(182, 6, 6) !important;
  }
}

.tournament-user-registration-form {
  // width: 100%;
  min-width: 180px;
  .input-wrapper-reg-form {
    word-wrap: break-word;
    word-break: break-all;
  }
  .playhera-label &.required {
    white-space: unset !important;
  }
  .mx-datepicker {
    width: 100%;
    &.date-picker .mx-input-wrapper input {
      max-width: unset;
    }
  }
}
</style>
